module.exports = __webpack_public_path__ + "img/writing-not-done-dude.7cb11e35.svg";